<app-breadcrumb></app-breadcrumb>
<app-loader></app-loader>
<mat-card class="cardWithShadow p-t-10">
    <mat-card-content class="p-24 cardWithShadow">
        <div class="row justify-content-between gap-16 p-x-10 p-b-10">
            <div class="col-lg-4">
                <mat-form-field appearance="outline" class="w-100 hide-hint ">
                    <input matInput placeholder="{{ 'LABEL.SEARCH_LABEL' | translate }} {{ 'ENTITY.USER' | translate }}"
                        [formControl]="searchuser" />
                    <mat-icon matSuffix>
                        <i-tabler name="search" class="icon-20 d-flex m-t-2"></i-tabler>
                    </mat-icon>
                </mat-form-field>
            </div>
            <div class="col-lg-4 d-flex align-items-center justify-content-end">
                <button *ngIf="usercount < max_users" mat-flat-button color="primary" class="cardWithShadow"
                    (click)="addUser()">
                    <mat-icon>add</mat-icon>
                    {{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.USER' | translate }}
                </button>
            </div>
        </div>
    </mat-card-content>
</mat-card>
<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<mat-card class="cardWithShadow m-0">
    <mat-card-content>
        <div class="table-responsive table-scroll-container-full">
            <table mat-table [dataSource]="dataSource" class="w-100">

                <ng-container matColumnDef="fullname">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">{{ 'LABEL.FULL_NAME_LABEL' | translate
                        }}</th>
                    <td mat-cell *matCellDef="let element">
                        <div class="d-flex align-items-center">
                            @if (element.avatar) {
                            <img class="rounded-circle" [src]="staticimagepath + element.avatar" width="40"
                                fallbackImage="assets/images/profile/user-1.jpg" />
                            }@else {
                            <img class="rounded-circle" [src]="'assets/images/profile/user-1.jpg'" width="40" />
                            }


                            <div class="m-l-16">
                                <p class="f-w-600 mat-subtitle-1 f-s-16 m-0">
                                    {{element.firstName}}
                                </p>
                                <small class="mat-body-1 f-s-14">{{element.lastName}}</small>
                            </div>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="birthDate">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.DOB_LABEL' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14">
                        {{element.birthDate|date}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="joinDate">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.JOINDATE_LABEL' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14">
                        {{element.joinDate|date}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="username">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.USERNAME' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14">
                        {{element.userName}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="roleName">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.ROLENAME' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14">
                        {{element.roleName}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.EMAIL_LABEL' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14">
                        {{element.email}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="phoneno">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.PHONE_LABEL' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14">
                        {{element.phoneNumber}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="panNumber">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.PAN_LABEL' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14">
                        {{ element.panNumber | maskSensitive }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="aadhaarNumber">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.AADHAR_LABEL' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14">
                        {{ element.aadhaarNumber | maskSensitive }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.ACTION_LABEL' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="action-link">
                        <a class="m-r-10 cursor-pointer" (click)="editOpenDialog(element)">
                            <i-tabler name="edit" class="icon-18"></i-tabler>
                        </a>
                        <a class="m-r-10 cursor-pointer" (click)="deleteDialog(element.id)">
                            <i-tabler name="trash" class="icon-18"></i-tabler>
                        </a>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>

            <mat-paginator class="paginator-fixed" [ngClass]="{'pointer-events-none': isLoading}"
                [length]="pagination.rowCount" [pageSize]="pagination.pageSize" [pageSizeOptions]="pageSizeOptions"
                [showFirstLastButtons]="true" [pageIndex]="pagination.currentPage">
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>